import { render, staticRenderFns } from "./Battle.vue?vue&type=template&id=28ab5339&scoped=true&"
import script from "./Battle.vue?vue&type=script&lang=js&"
export * from "./Battle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ab5339",
  null
  
)

export default component.exports